// extracted by mini-css-extract-plugin
export default {"link-arrow":"link-arrow--LBxlC","link-arrow__text":"link-arrow__text--FF3VM"};